module.exports = __webpack_public_path__ + "media/images/event/event-template-az-65b8a47ac98fdaf079c283c6b19ff85f.png";